import cn from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, WidgetCard } from '@/shared/ui';

import { OrderReport } from '@/widgets/OrderReport';

import styles from './NewReportMenu.module.scss';

type NewReportMenuProps = {
  className?: string;
};

export const NewReportMenu: FC<NewReportMenuProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      ref={containerRef}
      className={cn(styles.container, className)}
      data-component="new-report-menu"
    >
      <Button
        icon="plus"
        size="large"
        data-component="create-ai-report-button"
        onClick={() => setIsOpen((current) => !current)}
      >
        <FormattedMessage
          id="orderReport.title"
          defaultMessage="Create AI report"
        />
      </Button>

      {isOpen && (
        // Every item opens a modal or navigates away, so the menu closes on
        // any click inside it.
        <WidgetCard className={styles.menu} onClick={() => setIsOpen(false)}>
          <OrderReport />
        </WidgetCard>
      )}
    </div>
  );
};
